/**
 * AISport 手机端远程选人上场 - MQTT / 本地 HTTP 控制服务
 * 对接文档：《手机端选人上场对接文档 v1.0.0》
 *
 * 下行控制 Topic: aisport/device/{deviceId}/phone/control  (Publish, QoS 1)
 * 上行状态 Topic: aisport/device/{deviceId}/status/up      (Subscribe, QoS 1)
 * 本地直连 HTTP: POST http://{deviceIp}:8080/api/phone/control
 *
 * 注意：浏览器 mqtt.js 只能走 WebSocket，云端 Broker 已为前端增开 wss 端口（38084）。
 * 原生 TCP MQTTS 走 38883 供设备端/后端使用；浏览器无法跳过自签名证书校验
 * （rejectUnauthorized 在浏览器端无效），wss 端口需配置正规 CA 证书。
 */
// 说明：本项目已在 public/index.html 全局引入本地化的 mqtt@4.3.7（public/js/mqtt.min.js，
// ES5 语法，兼容老旧安卓/微信 WebView；5.x 新版用了 Array.prototype.at 会报
// "b.at is not a function"），与 outdoorRunning/cloudPlatform 页面同一用法，直接使用 window.mqtt。
/* global mqtt */

// ==================== 实验室测试机默认配置（文档 1.2） ====================
export const LAB_TEST_DEVICE = {
  code: 'b661031a0c9ddb88507395067e06e64c',
  deviceId: 'b661031a0c9ddb88507395067e06e64c',
  ip: '192.168.10.33',
  remark: '实验室测试机 (192.168.10.33)',
};

// ==================== Broker 配置 ====================
export const MQTT_BROKER_URL = 'wss://tiaotiao.xtotoro.com:38084/mqtt';
export const MQTT_USERNAME = '647dbccde3741e5d938f7ff5c9686e5b';
export const MQTT_PASSWORD = 'fUGfzM5eu-xXkJ2ChpgFy6GCwdTaT0w3';
// ==================================================================================

// 工位阶段代码（文档 5.1）
export const SLOT_STAGE = {
  READY: '02001',      // 准备阶段（在圈内或等候进圈）
  COUNTDOWN: '02011',  // 3-2-1 准备倒计时中
  TESTING: '03001',    // 正式测试中
  FINISHED: '04021',   // 测试已结束
};

// 支持的项目编码列表（当前暂时写死 5 个项目，工位限制为 8 个）
export const PROJECT_OPTIONS = [
  {
    id: 'newtiao_default_1',
    code: 'RopeSkipping',
    projectCode: 'RopeSkipping',
    projectType: 'tiaotiao_new',
    unit: '次',
    projectUnit: '次',
    name: '跳绳',
    projectName: '跳绳',
    deviceId: 'defaultProject',
    schoolCode: 'LMWZ',
    status: '0',
    createId: null,
    createName: null,
    createTime: null,
    updateId: null,
    updateName: null,
    updateTime: null,
    sobId: null,
    sobCode: null,
    sort: 1,
    singleSlot: false,
    maxSlots: 8,
    defaultDuration: 60,
  },
  {
    id: 'newtiao_default_2',
    code: 'JumpingJack',
    projectCode: 'JumpingJack',
    projectType: 'tiaotiao_new',
    unit: '次',
    projectUnit: '次',
    name: '开合跳',
    projectName: '开合跳',
    deviceId: 'defaultProject',
    schoolCode: 'LMWZ',
    status: '0',
    createId: null,
    createName: null,
    createTime: null,
    updateId: null,
    updateName: null,
    updateTime: null,
    sobId: null,
    sobCode: null,
    sort: 2,
    singleSlot: false,
    maxSlots: 8,
    defaultDuration: 60,
  },
  {
    id: 'newtiao_default_3',
    code: 'LeftRightJump',
    projectCode: 'LeftRightJump',
    projectType: 'tiaotiao_new',
    unit: '次',
    projectUnit: '次',
    name: '左右跳',
    projectName: '左右跳',
    deviceId: 'defaultProject',
    schoolCode: 'LMWZ',
    status: '0',
    createId: null,
    createName: null,
    createTime: null,
    updateId: null,
    updateName: null,
    updateTime: null,
    sobId: null,
    sobCode: null,
    sort: 3,
    singleSlot: false,
    maxSlots: 8,
    defaultDuration: 60,
  },
  {
    id: 'newtiao_default_4',
    code: 'DeepSquat',
    projectCode: 'DeepSquat',
    projectType: 'tiaotiao_new',
    unit: '次',
    projectUnit: '次',
    name: '深蹲',
    projectName: '深蹲',
    deviceId: 'defaultProject',
    schoolCode: 'LMWZ',
    status: '0',
    createId: null,
    createName: null,
    createTime: null,
    updateId: null,
    updateName: null,
    updateTime: null,
    sobId: null,
    sobCode: null,
    sort: 4,
    singleSlot: false,
    maxSlots: 8,
    defaultDuration: 60,
  },
  {
    id: 'newtiao_default_5',
    code: 'SquatJump',
    projectCode: 'SquatJump',
    projectType: 'tiaotiao_new',
    unit: '次',
    projectUnit: '次',
    name: '蹲跳',
    projectName: '蹲跳',
    deviceId: 'defaultProject',
    schoolCode: 'LMWZ',
    status: '0',
    createId: null,
    createName: null,
    createTime: null,
    updateId: null,
    updateName: null,
    updateTime: null,
    sobId: null,
    sobCode: null,
    sort: 5,
    singleSlot: false,
    maxSlots: 8,
    defaultDuration: 60,
  },
];

/**
 * 本地局域网 HTTP 直连调试发送指令（文档 2.2）
 * @param {string} deviceIp 设备局域网 IP（例如 '192.168.10.33'）
 * @param {string} action 控制指令 ('enter' | 'assign' | 'start' | 'stop' | 'abort' | 'exit')
 * @param {object} extra 附加参数（例如 { projectCode, duration, players, pointId }）
 * @returns {Promise<object>}
 */
export function sendLocalHttpControl(deviceIp, action, extra = {}) {
  if (!deviceIp) {
    return Promise.reject(new Error('deviceIp 不能为空'));
  }
  const url = `http://${deviceIp}:8080/api/phone/control`;
  const pointId = extra.pointId || `req_${action}_${Date.now()}`;
  const payload = {
    type: 'phoneControl',
    action,
    pointId,
    ...extra,
  };
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }).then((res) => res.json());
}

export class AISportPhoneController {
  /**
   * @param {string} deviceId 设备 32 位唯一标识
   * @param {object} handlers 事件回调 { onReady, onError, onClose, onAck, onSlotStatus, onLiveScore, onTestFinished }
   * @param {object} options 可选配置 { deviceIp, useHttp }
   */
  constructor(deviceId, handlers = {}, options = {}) {
    this.deviceId = deviceId;
    this.handlers = handlers;
    this.options = options;
    this.deviceIp = options.deviceIp || handlers.deviceIp || '';
    this.useHttp = !!(options.useHttp || handlers.useHttp);
    this.client = null;
    this.subTopic = `aisport/device/${deviceId}/status/up`;
    this.pubTopic = `aisport/device/${deviceId}/phone/control`;
  }

  /**
   * 动态设置/更新局域网 HTTP 调试配置
   * @param {object} param0 { deviceIp, useHttp }
   */
  setHttpOptions({ deviceIp, useHttp } = {}) {
    if (deviceIp !== undefined) this.deviceIp = deviceIp;
    if (useHttp !== undefined) this.useHttp = !!useHttp;
  }

  get connected() {
    return !!(this.client && this.client.connected);
  }

  connect() {
    if (this.client) this.disconnect();
    const mqttLib = (typeof mqtt !== 'undefined') ? mqtt : window.mqtt;
    if (!mqttLib) {
      const err = new Error('mqtt.js 未加载（请确认 public/js/mqtt.min.js 存在且 index.html 已引入）');
      setTimeout(() => { this.handlers.onError && this.handlers.onError(err); }, 0);
      return;
    }
    const options = {
      username: MQTT_USERNAME,
      password: MQTT_PASSWORD,
      // 防踢规则：严禁与设备端 deviceId 重名（文档 1.3）
      clientId: `phone_${this.deviceId}_${Math.random().toString(16).substring(2, 8)}`,
      clean: true,
      keepalive: 20,
      reconnectPeriod: 3000,
      connectTimeout: 10000,
    };
    this.client = mqttLib.connect(MQTT_BROKER_URL, options);

    this.client.on('connect', () => {
      this.client.subscribe(this.subTopic, { qos: 1 }, (err) => {
        if (err) {
          this.handlers.onError && this.handlers.onError(err);
          return;
        }
        this.handlers.onReady && this.handlers.onReady();
      });
    });
    this.client.on('error', (err) => {
      this.handlers.onError && this.handlers.onError(err);
    });
    this.client.on('close', () => {
      this.handlers.onClose && this.handlers.onClose();
    });
    this.client.on('message', (topic, payload) => {
      if (topic !== this.subTopic) return;
      let msg;
      try {
        msg = JSON.parse(payload.toString());
      } catch (e) {
        console.error('[AISport] 设备报文解析失败:', e);
        return;
      }
      // 兼容网关 body 包裹（文档 4.1）
      if (msg && msg.body && typeof msg.body === 'object' && !msg.action) {
        msg = msg.body;
      }
      // 联调日志：所有设备上行消息打印到控制台，便于确认 Topic 是否有任何回包
      console.log('[AISport] 收到设备上行:', msg && msg.action, msg);
      this._dispatch(msg);
    });
  }

  _dispatch(msg) {
    if (!msg || !msg.action) return;
    switch (msg.action) {
      case 'phone_control_ack':
        // 兼容处理：若 reason 为空但存在 message 且为 error 状态，自动回填 reason
        if (!msg.reason && msg.message && msg.status === 'error') {
          msg.reason = msg.message;
        }
        this.handlers.onAck && this.handlers.onAck(msg);
        break;
      case 'phone_slot_status':
        this.handlers.onSlotStatus && this.handlers.onSlotStatus(msg);
        break;
      case 'phone_live_score':
        this.handlers.onLiveScore && this.handlers.onLiveScore(msg);
        break;
      case 'phone_test_finished':
        this.handlers.onTestFinished && this.handlers.onTestFinished(msg);
        break;
      default:
        break;
    }
  }

  _send(action, extra = {}) {
    const hasMqtt = this.connected;
    const hasHttp = !!(this.useHttp && this.deviceIp);

    if (!hasMqtt && !hasHttp) {
      throw new Error('MQTT 尚未连接且未配置局域网 HTTP 直连，无法发送指令');
    }

    const payload = {
      type: 'phoneControl',
      action,
      pointId: extra.pointId || `req_${action}_${Date.now()}`,
      ...extra,
    };

    if (hasMqtt) {
      this.client.publish(this.pubTopic, JSON.stringify(payload), { qos: 1 });
      console.log('[AISport] 已下发 MQTT 指令:', this.pubTopic, payload);
    }

    if (hasHttp) {
      sendLocalHttpControl(this.deviceIp, action, payload)
        .then((res) => {
          console.log('[AISport] HTTP 直连响应:', res);
        })
        .catch((err) => {
          console.warn('[AISport] HTTP 直连发送失败:', err);
        });
    }

    return payload.pointId;
  }

  /**
   * 手动触发一次局域网 HTTP 直连指令
   * @param {string} action
   * @param {object} extra
   */
  sendLocalHttp(action, extra = {}) {
    if (!this.deviceIp) {
      return Promise.reject(new Error('未配置 deviceIp'));
    }
    return sendLocalHttpControl(this.deviceIp, action, extra);
  }

  /** 进入手机受控模式 */
  enter(projectCode = 'RopeSkipping') {
    return this._send('enter', { projectCode });
  }

  /**
   * 选人排号
   * @param {Array} players 考生列表 [{slot, snCode, studentName, className, classId, gradeName, studentGrade, schoolCode, schoolName}]
   * @param {number} duration 倒计时时长（秒），0~3600（0 表示继承项目默认时长）
   * @param {string} projectCode 切换项目编码（可选）
   */
  assign(players, duration = 0, projectCode) {
    if (!Array.isArray(players) || players.length === 0) {
      throw new Error('分配考生列表(players)不能为空');
    }
    const normalizedDuration = Math.max(0, Math.min(3600, Math.floor(Number(duration) || 0)));
    const normalizedPlayers = players.map((p, idx) => ({
      ...p,
      slot: Math.floor(Number(p.slot)) || (idx + 1),
    }));
    const extra = { duration: normalizedDuration, players: normalizedPlayers };
    if (projectCode) extra.projectCode = projectCode;
    return this._send('assign', extra);
  }

  start() { return this._send('start'); }
  stop() { return this._send('stop'); }
  abort() { return this._send('abort'); }
  exit() { return this._send('exit'); }

  disconnect() {
    if (this.client) {
      try { this.client.end(true); } catch (e) { /* ignore */ }
      this.client = null;
    }
  }
}
